module.exports = __webpack_public_path__ + "media/images/undraw/shift/online_calendar-4403dfeca11ac82738457cacdf3fc8a1.png";